let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3aGx7")).then(() => parcelRequire('bj47Q'));